export default __webpack_public_path__ + "static/media/Group758.d42bd491.svg";